@if (showSearch) {
  <myre-dropdown
    #dropDown
    class="dataroom-dropdown"
    [class.stretch]="stretch"
    [list]="items"
    type="autocomplete"
    [placeholder]="placeholder"
    [longPlaceholder]="longPlaceholder"
    [ngModel]="value"
    [stretch]="stretch"
    [adaptWidth]="adaptWidth"
    [tertiary]="tertiary"
    [secondary]="!tertiary"
    [shortLength]="shortWidth"
    [longLength]="longWidth"
    [clearOnBlur]="true"
    (onInput)="emitOnInput($event)"
    (onSelect)="emitOnSelect($event)"
    (onFocus)="emitOnFocus()"
    (onBlur)="emitOnBlur()"
    (onStretchDone)="onStretchDone($event)"
    (initDone)="onInitDone()"
    icon="myre-icon-search"
  >
    <ng-template
      dropdownTemplate="item"
      let-item
      let-first="first"
      let-last="last"
      let-hovered="hovered"
      let-select="select"
    >
      <ng-container
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{
          $implicit: item,
          first: first,
          last: last,
          hovered: hovered,
          select: select,
        }"
      />
    </ng-template>
  </myre-dropdown>
}

@if (!showSearch) {
  <myre-nav-icon-btn
    [@appear]
    icon="myre-icon-search"
    (onClick)="activateSearch()"
  />
}
